import $ from "jquery"

function updateCart(response) {
  window.globalCart.setValue((prev) => ({
    ...prev,
    cartItems: Object.values(response.items),
    common: { ...response.common },
    discount: {
      ...response.general,
      totals: response.totals,
    },
    isLoading: false,
  }))

  if (response.items.length === 0) {
    window.nextCartRequest = null
  } else if (response.totals["is_external_data_used"]) {
    window.nextCartRequest = null
  } else {
    window.nextCartRequest = this
  }
}

const BASE_URL = ""
const { lang = "en" } = document.documentElement

export const addProduct = ({
  id,
  locale = lang,
  options = [],
  without_external_data = false,
}) => {
  return $.ajax({
    url: `${BASE_URL}/api/cart`,
    type: "POST",
    cache: false,
    // data: `product_variant_id=${id},options=['service-name_loss']`,
    data: {
      product_variant_id: id,
      options,
      ...(without_external_data === true && { without_external_data }),
    },
    dataType: "json",
    headers: {
      "Accept-Language": locale,
    },
    success(response) {
      updateCart.call(this, response)
    },
    error: (error) => {
      console.log(error)
    },
  })
}

export const deleteProduct = (id) => {
  return $.ajax({
    url: `${BASE_URL}/api/cart/${id}`,
    type: "DELETE",
    cache: false,
    dataType: "json",
    headers: {
      "Accept-Language": lang,
    },
    success(response) {
      updateCart.call(this, response)
    },
    error: (error) => {
      console.log(error)
    },
  })
}

export async function getCart() {
  return $.ajax({
    url: `/api/cart`,
    type: "GET",
    cache: false,
    data: `locale=${lang}`,
    dataType: "json",
    success(response) {
      updateCart.call(this, response)
    },
    error: (error) => {
      console.log(error)
    },
  })
}
